<template>
    <ProductForm :is-new="false"/>
</template>

<script>
import ProductForm from './ProductForm.vue';

export default {
    components: {
        ProductForm,
    },
};
</script>
